import { createGlobalStyle, css } from "styled-components";

export const narrowScreenMediaQuery = "screen and (max-width: 719px)";

const GlobalCSS = css`
  [data-error] {
    /* overcome specificity for onboarding-form-helpers */
    && {
      border: 1px solid #da3333;
    }
  }

  /* Modern default — keeps \`width: 100%\` + \`padding\` from overflowing. */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    --sticky-height: 0;
    scroll-padding-top: calc(1px * var(--sticky-height));
    scroll-behavior: smooth;

    @media (prefers-reduced-motion: reduce) {
      scroll-behavior: auto;
    }

    & body {
      margin: 0;
      & * {
        font-family: "Montserrat", sans-serif;
      }
    }
  }
`;

export const GlobalStyle = createGlobalStyle(GlobalCSS);
